module.exports = __webpack_public_path__ + "static/media/011.368520dd.jpg";